module.exports = __webpack_public_path__ + "static/media/notepad_grey.ba84f53c.png";